module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_8.1b947107.png";